module.exports = __webpack_public_path__ + "static/media/tooltip-icon.2826a8c6.svg";